module.exports = __webpack_public_path__ + "static/media/tablet.e48c1029.png";